import axios from 'axios'

const state = {
  commandeUploading: false,
  commandes: [],
  commandesLoading: false,
  fdp: 0
}

const actions = {
  /**
   * Service pour créer une commande.
   * @param {*} param0 
   * @returns 
   */
  createCommande({
    commit,
    dispatch
  }, commande) {
    return new Promise((resolve, reject) => {
      commit('setCommandeUploading', true)
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.post(process.env.VUE_APP_API_URL + '/users/' + commande.userId + '/commandes', commande, {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        }
      }).then(response => {
        commit('setCommandeUploading', false)
        resolve(response.data)
      }).catch(error => {
        commit('setCommandeUploading', false)
        reject(error)
      })
    })
  },
  /**
   * Service pour récupérer les nouvelles commandes.
   * @param {*} param0 
   * @returns 
   */
  getNouvellesCommandes({
    commit,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      commit('setCommandesLoading', true)
      axios.get(process.env.VUE_APP_API_URL + '/commandes', {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        },
        params: {
          est_archive: 0,
          est_annule: 0,
          est_expedie: 0,
          valide: 0
        }
      }).then(response => {
        commit('setCommandes', response.data)
        commit('setCommandesLoading', false)
        resolve(response)
      }).catch(error => {
        commit('setCommandesLoading', false)
        reject(error)
      })
    })
  },
  /**
   * Service pour récupérer les commandes à envoyer.
   * @param {*} param0 
   * @returns 
   */
  getCommandesAEnvoyer({
    commit,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      commit('setCommandesLoading', true)
      axios.get(process.env.VUE_APP_API_URL + '/commandes', {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        },
        params: {
          est_archive: 0,
          est_annule: 0,
          est_expedie: 0,
          valide: 1
        }
      }).then(response => {
        commit('setCommandes', response.data)
        commit('setCommandesLoading', false)
        resolve(response)
      }).catch(error => {
        commit('setCommandesLoading', false)
        reject(error)
      })
    })
  },
  /**
   * Service pour récupérer les commandes envoyées.
   * @param {*} param0 
   * @returns 
   */
  getCommandesEnvoyees({
    commit,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      commit('setCommandesLoading', true)
      axios.get(process.env.VUE_APP_API_URL + '/commandes', {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        },
        params: {
          est_archive: 0,
          est_annule: 0,
          est_expedie: 1,
          valide: 1
        }
      }).then(response => {
        commit('setCommandes', response.data)
        commit('setCommandesLoading', false)
        resolve(response)
      }).catch(error => {
        commit('setCommandesLoading', false)
        reject(error)
      })
    })
  },
  /**
   * Service pour récupérer les commandes archivées.
   * @param {*} param0 
   * @returns 
   */
  getCommandesArchivees({
    commit,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      commit('setCommandesLoading', true)
      axios.get(process.env.VUE_APP_API_URL + '/commandes', {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        },
        params: {
          est_archive: 1,
          est_annule: 0
        }
      }).then(response => {
        commit('setCommandes', response.data)
        commit('setCommandesLoading', false)
        resolve(response)
      }).catch(error => {
        commit('setCommandesLoading', false)
        reject(error)
      })
    })
  },
  /**
   * Service pour récupérer les commandes annulées.
   * @param {*} param0 
   * @returns 
   */
  getCommandesAnnulees({
    commit,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      commit('setCommandesLoading', true)
      axios.get(process.env.VUE_APP_API_URL + '/commandes', {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        },
        params: {
          est_annule: 1
        }
      }).then(response => {
        commit('setCommandes', response.data)
        commit('setCommandesLoading', false)
        resolve(response)
      }).catch(error => {
        commit('setCommandesLoading', false)
        reject(error)
      })
    })
  },

  /**
   * Service pour indiquer que la commande a bien été payée.
   * @param {*} param0 
   * @returns 
   */
  payCommande({
    commit,
    dispatch
  }, commande) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.put(process.env.VUE_APP_API_URL + '/commandes/' + commande.id + '/pay',
        commande, {
          headers: {
            Accept: 'application/json',
            Authorization: AuthStr,
          }
        }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * Service pour valider une commande.
   * @param {*} param0 
   * @returns 
   */
  validateCommande({
    commit,
    dispatch
  }, commande) {
    return new Promise((resolve, reject) => {
      commit('setCommandeUploading', true)
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.patch(process.env.VUE_APP_API_URL + '/commandes/' + commande.id + '/validate', {}, {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        }
      }).then(response => {
        commit('setCommandeUploading', false)
        resolve(response)
      }).catch(error => {
        commit('setCommandeUploading', false)
        reject(error)
      })
    })
  },

  /**
   * Service pour annuler une commande.
   * @param {*} param0 
   * @returns 
   */
  cancelCommande({
    commit,
    dispatch
  }, commande) {
    return new Promise((resolve, reject) => {
      commit('setCommandeUploading', true)
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.patch(process.env.VUE_APP_API_URL + '/commandes/' + commande.id + '/cancel', {}, {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        }
      }).then(response => {
        commit('setCommandeUploading', false)
        resolve(response)
      }).catch(error => {
        commit('setCommandeUploading', false)
        reject(error)
      })
    })
  },

  /**
   * Service pour expédier une commande.
   * @param {*} param0 
   * @returns 
   */
  shipCommande({
    commit,
    dispatch
  }, commande) {
    return new Promise((resolve, reject) => {
      commit('setCommandeUploading', true)
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.patch(process.env.VUE_APP_API_URL + '/commandes/' + commande.id + '/ship', {}, {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        }
      }).then(response => {
        commit('setCommandeUploading', false)
        resolve(response)
      }).catch(error => {
        commit('setCommandeUploading', false)
        reject(error)
      })
    })
  },

  /**
   * Service pour archiver une commande.
   * @param {*} param0 
   * @returns 
   */
  archiveCommande({
    commit,
    dispatch
  }, commande) {
    return new Promise((resolve, reject) => {
      commit('setCommandeUploading', true)
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.patch(process.env.VUE_APP_API_URL + '/commandes/' + commande.id + '/archive', {}, {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        }
      }).then(response => {
        commit('setCommandeUploading', false)
        resolve(response)
      }).catch(error => {
        commit('setCommandeUploading', false)
        reject(error)
      })
    })
  },

  /**
   * Service pour récupérer les commandes d'un utilisateur.
   * @param {*} param0 
   * @returns 
   */
  getUserCommandes({
    commit,
    dispatch
  }, userId) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      commit('setCommandesLoading', true)
      axios.get(process.env.VUE_APP_API_URL + '/users/' + userId + '/commandes', {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        },
        params: {
          en_cours: 1
        }
      }).then(response => {
        commit('setCommandes', response.data)
        commit('setCommandesLoading', false)
        resolve(response)
      }).catch(error => {
        commit('setCommandesLoading', false)
        reject(error)
      })
    })
  },
  /**
   * Service pour récupérer les frais de port.
   * @param {*} param0 
   * @returns 
   */
  getFraisDePort({
    commit,
    dispatch
  }, info) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      const AuthStr = 'Bearer ' + token
      axios.get(process.env.VUE_APP_API_URL + '/fdp', {
        headers: {
          Accept: 'application/json',
          Authorization: AuthStr,
        },
        params: {
          poids: info.poids,
          total: info.total
        }
      }).then(response => {
        commit('setFdp', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}


const getters = {
  commandeUploading: state => state.commandeUploading,
  commandes: state => state.commandes,
  commandesLoading: state => state.commandesLoading,
  fdp: state => state.fdp
}

const mutations = {
  setCommandeUploading(state, commandeUploading) {
    state.commandeUploading = commandeUploading
  },
  setCommandes(state, commandes) {
    state.commandes = commandes
  },
  setCommandesLoading(state, commandesLoading) {
    state.commandesLoading = commandesLoading
  },
  setFdp(state, fdp) {
    state.fdp = fdp
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}